import { render } from "./MailAliases.vue?vue&type=template&id=3c00e298&scoped=true"
import script from "./MailAliases.vue?vue&type=script&lang=js"
export * from "./MailAliases.vue?vue&type=script&lang=js"

import "./MailAliases.vue?vue&type=style&index=0&id=3c00e298&lang=scss&scoped=true"

import exportComponent from "/home/ben/Projects/harborwall-interface/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c00e298"]])

export default __exports__